// extracted by mini-css-extract-plugin
export default {"tooltip":"Hq-z","sharingV2":"Iq-z","sharingIconsV2":"Jq-z","links":"Kq-z","link":"Lq-z","facebookV2":"Mq-z","twitterV2":"Nq-z","pinterestV2":"Oq-z"};